import { render, staticRenderFns } from "./Salaryspecification.vue?vue&type=template&id=88a068da"
import script from "./Salaryspecification.vue?vue&type=script&lang=js"
export * from "./Salaryspecification.vue?vue&type=script&lang=js"
import style0 from "./Salaryspecification.vue?vue&type=style&index=0&id=88a068da&prod&ang=css&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports